import React from "react";
import { Grid, SemanticWIDTHS } from "semantic-ui-react";
import { GlobalConstants } from "../constants/GlobalConstants";
import BCFormInput from "../ui/BCFormInput";
import { convertToDateString, convertToYesNo, getDropdownOptions, handleAddressValue, handleFormChange, handleGetValueFromId, operationOfNumberArray } from "../../Helpers";
import BCAccordion from "../ui/BCAccordion";
import "../../styles/landing-page.scss";
import "../../styles/main.scss";
import "../../styles/bc-theme.scss";
import "../../styles/ui.scss";
import { FeatureFlags } from "../constants/LocalServerConstants";
import { BPQuestionLabels } from "./BPQuestionLabels";
import { ConfigDefaults } from "../constants/BrokerConstants";

interface IApplicationDetailSectionInput {
  value: any;
  sendBackValue?: any;
  label: string;
  size?: SemanticWIDTHS;
  unitType?: string;
  readonly?: boolean;
  field?: string;
  allowNegativeValue?: boolean;
  inputType?: string;
  condition?: boolean;
  dropdown?: any;
  address?: any;
  original?: any;
  format?: string;
  array?: any[];
  cost?: any[];
  metadata?: any;
  metadataArray?: any[];
  yesNo?: any;
  places?: any;
  persona?: any;
  gmrBorrowers?: any[];
  isOverride?: boolean;
}

interface IApplicationDetailSectionContentProps {
  isGreaterThanMobile: boolean;
  overrideFirstClassName?: string;
  accordionObject: any;
  setAccordionObject: (value: any) => any;
  isEditMode: boolean;
  handleFormChange: (value: string, field: string, obj: any, setObj: (value: any) => any, type: string, handleCustomFormChange? : any, charLimit? : number, index?: number) => void;
  index? : number;
  inputs?: IApplicationDetailSectionInput[];
  isLoanApplication?: boolean;
  borrowerApplicationInfo?: any;
  scenarios?: any[];
}

const ApplicationDetailSectionContent = ({ ...props }: IApplicationDetailSectionContentProps) => {
  const handleYesNoDropdownChange = (value, field, j) => {
    const booleanValue = value === "Yes" ? true : false;
    props.handleFormChange(
      booleanValue as any,
      field,
      props.accordionObject,
      props.setAccordionObject,
      GlobalConstants.InputTypes.STRING,
      undefined,
      undefined,
      j
    );
  };

  const handleSetPlacesAccordionObject = (value) => {
    delete props.accordionObject.cityName;
    delete props.accordionObject.countyName;
    delete props.accordionObject.projectZipCode;
    delete props.accordionObject.stateName;
    props.setAccordionObject(value);
  };

  return (
    <Grid className="primary-details-gmr">
      {props.inputs?.map((input, i) => {  
        if (input.condition !== false && ((input && input.label && (input.value || input.value === false)) || (input.yesNo && input.value === false))) {
          return (
            <Grid.Row key={i} className={`primary-details-color ${(props.overrideFirstClassName) ? props.overrideFirstClassName : ""}`}>
              <Grid.Column width={3} className="primary-details">
                <BCFormInput 
                  labelClass="pricing-scenario-label"
                  label={input.label}
                />
                {input.array && input.array.map((element, i) => {
                  return( <BCFormInput
                  key={i}
                  labelClass="gmr-background-label-indented"
                  label={"Property " + (i + 1)}
                />
                );})}
                {input.cost && input.cost.map((element, i) => {
                    return( <BCFormInput
                    key={i}
                    labelClass="gmr-background-label-indented"
                    label={"Cost: " + handleGetValueFromId(input.metadata.costTypes, element.gmrprojectCostId)}
                />
                );})}
              </Grid.Column>
              <Grid.Column className={`padding-columns ${(props.overrideFirstClassName) ? props.overrideFirstClassName : ""}`} key={`ApplicationDetailSectionInput-${i}`} width={props.isGreaterThanMobile ? input.size : 16}>
                {(input.dropdown && !input.yesNo) ? <BCFormInput 
                  type={props.overrideFirstClassName !== null ? "plainText" : "dropdown"}
                  placeholder="Please Select..."
                  value={(input.field && props.accordionObject[input.field]) ? props.accordionObject[input.field] : input.value}
                  obj={props.accordionObject}
                  field={input.field}
                  dropdownOptions={input.dropdown}
                  disabled={true}
                  /> : input.address ? input.address :
                  input.array ? <React.Fragment>
                    <div className="primary-details-original-padding" />
                    {input.array.map((element, i) => {
                      return ( 
                        <BCFormInput
                          fieldClass="primary-detail-array-item"
                          key={`MonthOfFirstDraw-${i}`}
                          type={"input"}
                          value={(element && element.monthOfFirstDraw) && element.monthOfFirstDraw}
                          field={element.monthOfFirstDraw}
                          fieldType={input.inputType ? input.inputType : (input.unitType && input.unitType === "$") ? GlobalConstants.InputTypes.FLOAT :
                            (input.unitType && input.unitType === "%") ? "percent" : null}
                          obj={props.accordionObject}
                          unitType={input.unitType}
                          disabled={true}
                          allowNegativeValue={input.allowNegativeValue}
                        />
                      );
                    })}
                  </React.Fragment> :
                  input.cost ? <React.Fragment>
                    <div className="primary-details-original-padding" />
                    {input.cost.map((element, i) => {
                    return(<BCFormInput
                      fieldClass="primary-detail-array-item"
                      key={`cost-paid-${i}`}
                      type="input"
                      value={(element && element.amount) && element.amount}
                      field={element.monthOfFirstDraw}
                      fieldType={input.inputType ? input.inputType : (input.unitType && input.unitType === "$") ? GlobalConstants.InputTypes.FLOAT :
                        (input.unitType && input.unitType === "%") ? "percent" : null}
                      obj={props.accordionObject}
                      unitType={input.unitType}
                      disabled={true}
                      allowNegativeValue={input.allowNegativeValue}
                    />);
                  })}
                  </React.Fragment> : <BCFormInput
                  type={props.overrideFirstClassName !== null ? "plainText" : "input"}
                  value={(input.yesNo && input.field) ? input.yesNo(input.value) : (input.field && props.accordionObject[input.field]) ? props.accordionObject[input.field] : input.value}
                  field={input.field}
                  fieldType={input.inputType ? input.inputType : (input.unitType && input.unitType === "$") ? GlobalConstants.InputTypes.FLOAT :
                    (input.unitType && input.unitType === "%") ? "percent" : null}
                  obj={props.accordionObject}
                  unitType={input.unitType}
                  disabled={true}
                  allowNegativeValue={input.allowNegativeValue}
                />}
              </Grid.Column>
              {props.scenarios && props.scenarios.map((scenario, j) => {
                let scenarioValue = null;
                if (input.value !== undefined && input.isOverride) {
                  scenarioValue = input.value;
                }
                else if (input.field) {
                  scenarioValue = scenario[input.field];
                }
                
                return (
                  <Grid.Column className="padding-columns" key={`ApplicationDetailSectionInput-${i}`}  width={props.isGreaterThanMobile ? input.size : 16}>
                    {input.places ? <BCFormInput
                      type={GlobalConstants.FormInputTypes.PLACES}
                      inputKey="pricing-overview"
                      placeDetailsObject={props.accordionObject}
                      setPlaceDetailsObject={(value) => handleSetPlacesAccordionObject(value)}
                      placeholder="98103"
                      defaultValue={input.field && scenario[input.field]}
                      placeFields={["city", "state", "county", "zip"]}
                      placeFieldsNameOverrides={[
                        {
                          addressComponent: "zip",
                          field: "projectZipCode"
                        },
                        {
                          addressComponent: "city",
                          field: "cityName"
                        },
                        {
                          addressComponent: "state",
                          field: "stateName"
                        },
                        {
                          addressComponent: "county",
                          field: "countyName"
                        }
                      ]}
                      handleFormChange={(value, field) => props.handleFormChange(
                        value,
                        field,
                        props.accordionObject,
                        props.setAccordionObject,
                        GlobalConstants.InputTypes.STRING,
                        undefined,
                        undefined,
                        j
                      )}
                      autofillOverrides={["zip"]}
                      fieldType={GlobalConstants.InputTypes.ZIP}
                      searchScopeOptions={GlobalConstants.ZipSearchScopeOptions}
                      required
                    /> : (input.dropdown && input.yesNo) ? <BCFormInput 
                      type="dropdown"
                      placeholder="Please Select..."
                      value={(input.field && scenarioValue) ? "Yes" : "No"}
                      obj={scenario}
                      field={input.field}
                      dropdownOptions={input.dropdown}
                      handleFormChange={(value, field) => handleYesNoDropdownChange(value, field, j)}
                      disabled={!props.isEditMode || input.readonly} 
                    /> : input.dropdown ? <BCFormInput 
                      type="dropdown"
                      placeholder="Please Select..."
                      value={input.field && scenario[input.field]}
                      obj={scenario}
                      field={input.field}
                      dropdownOptions={input.dropdown}
                      handleFormChange={(value, field) => props.handleFormChange(
                        value,
                        field,
                        props.accordionObject,
                        props.setAccordionObject,
                        input.inputType ? input.inputType : input.unitType === "$" ? GlobalConstants.InputTypes.FLOAT : GlobalConstants.InputTypes.STRING,
                        undefined,
                        undefined,
                        j
                      )}
                      disabled={!props.isEditMode || input.readonly} 
                    /> : input.address ? input.address : input.array ? input.array.map((element, i) => {
                      if (i === 0) {
                        return( 
                          <React.Fragment key={`monthOfFirstDrawDetail-${i}`}>
                            <div className="primary-details-padding" />
                            <BCFormInput
                              fieldClass="primary-detail-array-item"
                              type="input"
                              value={(element && element.monthOfFirstDraw) && element.monthOfFirstDraw}
                              field={element.monthOfFirstDraw}
                              fieldType={input.inputType ? input.inputType : (input.unitType && input.unitType === "$") ? GlobalConstants.InputTypes.FLOAT :
                                (input.unitType && input.unitType === "%") ? "percent" : null}
                              obj={props.accordionObject}
                              unitType={input.unitType}
                              disabled={true}
                              allowNegativeValue={input.allowNegativeValue}
                            />
                          </React.Fragment>
                        );
                      }
                      else{
                      return(<BCFormInput
                        fieldClass="primary-detail-array-item"
                        type="input"
                        value={(element && element.monthOfFirstDraw) && element.monthOfFirstDraw}
                        field={element.monthOfFirstDraw}
                        fieldType={input.inputType ? input.inputType : (input.unitType && input.unitType === "$") ? GlobalConstants.InputTypes.FLOAT :
                          (input.unitType && input.unitType === "%") ? "percent" : null}
                        obj={props.accordionObject}
                        unitType={input.unitType}
                        disabled={true}
                        allowNegativeValue={input.allowNegativeValue}
                      />);}
                    }) : input.cost ? input.cost.map((element, i) => {
                      if (i === 0) {
                        return( 
                          <React.Fragment>
                            <div className="primary-details-padding" />
                            <BCFormInput
                              fieldClass="primary-detail-array-item"
                              type="input"
                              value={(element && element.amount) && element.amount}
                              field={element.amount}
                              fieldType={input.inputType ? input.inputType : (input.unitType && input.unitType === "$") ? GlobalConstants.InputTypes.FLOAT :
                                (input.unitType && input.unitType === "%") ? "percent" : null}
                              obj={props.accordionObject}
                              unitType={input.unitType}
                              disabled={true}
                              allowNegativeValue={input.allowNegativeValue}
                            />
                          </React.Fragment>
                        );
                      }
                      return ( 
                        <BCFormInput
                          fieldClass="primary-detail-array-item"
                          type="input"
                          value={(element && element.amount) && element.amount}
                          field={element.amount}
                          fieldType={input.inputType ? input.inputType : (input.unitType && input.unitType === "$") ? GlobalConstants.InputTypes.FLOAT :
                            (input.unitType && input.unitType === "%") ? "percent" : null}
                          obj={props.accordionObject}
                          unitType={input.unitType}
                          disabled={true}
                          allowNegativeValue={input.allowNegativeValue}
                        />
                      );
                    }) : <BCFormInput
                      type="input"
                      value={(input.yesNo && input.field) ? input.yesNo(scenarioValue) : (input.field && scenarioValue) ? scenarioValue : null}
                      obj={scenario}
                      field={input.field}
                      fieldType={input.inputType ? input.inputType : (input.unitType && input.unitType === "$") ? GlobalConstants.InputTypes.DOLLAR :
                        (input.unitType && input.unitType === "%") ? "percent" : null}
                      handleFormChange={(value, field) => props.handleFormChange(
                        value,
                        field,
                        props.scenarios,
                        props.setAccordionObject,
                        input.inputType ? input.inputType : input.unitType === "$" ? GlobalConstants.InputTypes.FLOAT : GlobalConstants.InputTypes.STRING,
                        undefined,
                        undefined,
                        j
                      )}
                      format={input.format}
                      unitType={input.unitType}
                      disabled={!props.isEditMode || input.readonly}
                      allowNegativeValue={input.allowNegativeValue}
                    />}
                    <div></div>
                  </Grid.Column>
                );
              })}
            </Grid.Row>
          );
        }
        else {
          return null;
        }
      })}
    </Grid>
  );
};

const BPPricingScenario = ({...props}) => {
  let minMandatoryBrokerFee = ConfigDefaults.MIN_MANDATORY_BROKER_FEE;
  if (props.gmrMetadata && props.gmrMetadata.configs) {
    minMandatoryBrokerFee = props.gmrMetadata.configs.minMandatoryBrokerFee;
  }

  const handleTransformGmrObjectWithInfo = (gmrObject) => {
    if (gmrObject.borrowerInfo) {
      gmrObject.borrowerCompanyName = gmrObject.borrowerInfo.companyName;
      gmrObject.borrowerEntitySubTypeId = gmrObject.borrowerInfo.entitySubTypeId;
      gmrObject.borrowerStreet = gmrObject.borrowerInfo.street;
      gmrObject.borrowerCityName = gmrObject.borrowerInfo.cityName;
      gmrObject.borrowerStateName = gmrObject.borrowerInfo.stateName;
      gmrObject.borrowerCountyName = gmrObject.borrowerInfo.countyName;
      gmrObject.borrowerZip = gmrObject.borrowerInfo.zip;
    }
    
    return gmrObject;
  };

  const handleScenarioFormChange = (value, field, obj, setObj, type = "string", handleCustomFormChange = undefined as any, charLimit = undefined as number | undefined, index = -1 as number) => {
    handleFormChange(value, field, obj, setObj, type, handleCustomFormChange, charLimit, index);
    props.setIsRecalculateValid(true);
  };

  const pricingAccordion = {
    index: 0,
    title: "PRICING QUOTE",
    otherContent: <ApplicationDetailSectionContent
      isGreaterThanMobile={props.isGreaterThanMobile}
      isEditMode={false}
      overrideFirstClassName="original-scenario-field"
      setAccordionObject={props.setGmrScenarios}
      accordionObject={props.gmrScenarios}
      handleFormChange={handleScenarioFormChange}
      scenarios={props.gmrScenarios}
      inputs={[
        {
          label: "Loan Commitment",
          value: props.gmrObject.loanCommitment,
          field: "loanCommitment",
          size: 4,
          readonly: true,
          inputType: "dollar"
        },
        {
          label: "Interest Rate",
          value: props.gmrObject.interestRate ,
          field: "interestRate",
          size: 4,
          readonly: true,
          inputType: "percent"
        },
        {
          label: "Loan Origination",
          value: props.gmrObject.originationFeeRate,
          field: "originationFeeRate",
          size: 4,
          readonly: true,
          inputType: "percent"
        },
        {
          label: "Loan Term (Months)",
          value: props.gmrObject.loanTermInMonths,
          field: "loanTermInMonths",
          size: 4,
          readonly: true,
          inputType: "Months"
        },
        {
          label: "Requested Down Payment",
          value: props.gmrObject.cashDown,
          field: "cashDown",
          size: 4,
          readonly: true,
          inputType: "dollar"
        },
        {
          label: "WIP at Closing",
          value: props.gmrObject.wipAtClosing,
          field: "wipAtClosing",
          size: 4,
          readonly: true,
          inputType: "dollar"
        },
        {
          label: "Estimated Cash Down",
          value: props.gmrObject.requiredCashDown,
          field: "requiredCashDown",
          size: 4,
          readonly: true,
          inputType: "dollar"
        },
        {
          label: "Estimated Closing Date",
          value: props.gmrObject.estimatedClosingDate && convertToDateString(new Date(props.gmrObject.estimatedClosingDate)),
          field: "estimatedClosingDate",
          size: 4,
          readonly: true
        },
        {
          label: "Estimated Maturity Date",
          value: props.gmrObject.estimatedMaturityDate && convertToDateString(new Date(props.gmrObject.estimatedMaturityDate)),
          field: "estimatedMaturityDate",
          size: 4,
          readonly: true
        },
        {
          label: "LTV",
          value: props.gmrObject.ltv,
          field: "ltv",
          size: 4,
          readonly: true,
          inputType: "percent"
        },
        {
          label: "LTC",
          value: props.gmrObject.ltc,
          field: "ltc",
          size: 4,
          readonly: true,
          inputType: "percent"
      }]}
    />
  };

  const overviewAccordion = {
    index: 0,
    title: "OVERVIEW",
    otherContent: <ApplicationDetailSectionContent
      isGreaterThanMobile={props.isGreaterThanMobile}
      isEditMode={true}
      overrideFirstClassName="original-scenario-field"
      setAccordionObject={props.setGmrScenarios}
      accordionObject={props.gmrScenarios}
      handleFormChange={handleScenarioFormChange}
      scenarios={props.gmrScenarios}
      inputs={[
        {
          label: "Loan type",
          field: "loanProgramId",
          value: handleGetValueFromId(props.gmrMetadata.loanPrograms, props.gmrObject.loanProgramId),
          size: 4,
          readonly: true,
          dropdown: props.gmrMetadata.propertyTypes && getDropdownOptions(props.gmrMetadata.loanPrograms, ["id"], "name"),
          metadataArray: props.gmrMetadata.loanPrograms
        },
        {
          label: "Structure type",
          field: "propertyTypeId",
          value: handleGetValueFromId(props.gmrMetadata.propertyTypes, props.gmrObject.propertyTypeId),
          size: 4,
          dropdown: props.gmrMetadata.propertyTypes && getDropdownOptions(props.gmrMetadata.propertyTypes, ["id"], "name"),
          metadataArray: props.gmrMetadata.propertyTypes
        },
        {
          label: "Project name",
          field: "name",
          value: props.gmrObject.name,
          size: 4,
          readonly: true
        },
        {
          label: "Zip code",
          field: "projectZipCode",
          value: props.gmrObject.projectZipCode,
          places: true,
          size: 4
      }]}
    />
  };

  const budgetAccordion = {
    index: 0,
    title: "BUDGET",
    otherContent: <ApplicationDetailSectionContent
      isGreaterThanMobile={props.isGreaterThanMobile}
      isEditMode={true}
      overrideFirstClassName="original-scenario-field"
      setAccordionObject={props.setGmrScenarios}
      accordionObject={props.gmrScenarios}
      handleFormChange={handleScenarioFormChange}
      scenarios={props.gmrScenarios}
      inputs={[
        {
          label: "Purchase / Refinance price",
          field: "refinancePayoff",
          value: props.gmrObject.refinancePayoff,
          size: 4,
          inputType: "dollar"
        },
        {
          label: "Property Value",
          field: "asIsValue",
          value: props.gmrObject.asIsValue,
          size: 4,
          inputType: "dollar"
        },
        {
          label: "Requested construction budget",
          field: "budget",
          value: props.gmrObject.budget,
          size: 4,
          inputType: "dollar"
        },
        {
          label: "Expected finished value",
          field: "afterRepairValue",
          value: props.gmrObject.afterRepairValue,
          size: 4,
          inputType: "dollar"
      }]}
    />
  };

  const projectAccordion = {
    index: 0,
    title: "PROJECT",
    otherContent: <ApplicationDetailSectionContent
      isGreaterThanMobile={props.isGreaterThanMobile}
      isEditMode={true}
      overrideFirstClassName="original-scenario-field"
      setAccordionObject={props.setGmrScenarios}
      accordionObject={props.gmrScenarios}
      handleFormChange={handleScenarioFormChange}
      scenarios={props.gmrScenarios}
      inputs={[
        {
          label: "Number of properties",
          field: "numberOfPropertiesOrUnits",
          value: props.gmrObject.numberOfPropertiesOrUnits,
          size: 4,
          readonly: true
        },
        {
          label: "Number of months to build each property",
          field: "totalBuildTimeInMonths",
          value: props.gmrObject.totalBuildTimeInMonths,
          size: 4,
          inputType: "months"
        },
        {
          label: "Month of first draw",
          field: "gmrUnitDrawMonths",
          value: props.gmrObject.gmrUnitDrawMonths,
          array: props.gmrObject.gmrUnitDrawMonths,
          size: 4
      }]}
    />
  };

  const financingAccordion = {
    index: 0,
    title: "FINANCING",
    otherContent: <ApplicationDetailSectionContent
      isGreaterThanMobile={props.isGreaterThanMobile}
      isEditMode={true}
      overrideFirstClassName="original-scenario-field"
      setAccordionObject={props.setGmrScenarios}
      accordionObject={props.gmrScenarios}
      handleFormChange={handleScenarioFormChange}
      scenarios={props.gmrScenarios}
      inputs={[
        {
          label: "Requested loan term in months",
          field: "requestedLoanTermInMonths",
          value: props.gmrObject.requestedLoanTermInMonths,
          size: 4,
          inputType: "months"
        },
        {
          label: "Prefer to use interest reserve",
          field: "useInterestReserve",
          value: props.gmrObject.useInterestReserve,
          size: 4,
          yesNo: convertToYesNo, 
          readonly: true
        },
        {
          label: "Requested cash down payment",
          field: "cashDown",
          value: props.gmrObject.cashDown,
          size: 4,
          inputType: "dollar"
        },
        {
          label: "Total costs paid to date",
          field: "gmrCostPaids",
          value: props.gmrObject.gmrCostPaids,
          cost: props.gmrObject.gmrCostPaids,
          metadata: props.gmrMetadata,
          size: 4
      }]}
    />
  };

  const backgroundAccordion = {
    index: 0,
    title: "BACKGROUND",
    otherContent: <ApplicationDetailSectionContent
      isGreaterThanMobile={props.isGreaterThanMobile}
      isEditMode={true}
      overrideFirstClassName="original-scenario-field"
      setAccordionObject={props.setGmrScenarios}
      accordionObject={props.gmrScenarios}
      handleFormChange={handleScenarioFormChange}
      scenarios={props.gmrScenarios}
      inputs={[
        {
          label: "Cumulative project experience",
          field: "projectExperience",
          value: props.gmrObject.projectExperience,
          size: 4
        },
        {
          label: "Best estimated credit score",
          field: "creditScore",
          value: props.gmrObject.creditScore,
          inputType: GlobalConstants.InputTypes.CREDIT,
          size: 4
        },
        {
          label: FeatureFlags.IS_BROKER_FEE_ALLIANCE ? BPQuestionLabels.BrokerFeeRate : BPQuestionLabels.BrokerFeeRateRebate,
          field: "brokerFeeRate",
          value: props.gmrObject.brokerFeeRate,
          size: 4,
          inputType: "percent"
        },
        {
          label: BPQuestionLabels.CombineOriginationFeeRate,
          field: "isCombineOriginationFee",
          value: props.gmrObject.isCombineOriginationFee ? "Yes" : "No",
          size: 4,
          dropdown: [
            {
              key: "56ab2483-9fa5-4c13-b62b-870f24cff5c2",
              text: "Yes",
              value: "Yes"
            },
            {
              key: "38b2295e-ee0c-4fc2-932d-aef4a8bac31e",
              text: "No",
              value: "No"
            }
          ],
          yesNo: convertToYesNo,
          condition: !FeatureFlags.IS_BROKER_FEE_ALLIANCE
        },
        {
          label: BPQuestionLabels.WlBrokerFeeRate,
          field: "wlbrokerFeeRate",
          value: props.gmrObject.wlbrokerFeeRate,
          size: 4,
          inputType: "percent",
          condition: FeatureFlags.IS_BROKER_FEE_ALLIANCE
        },
        {
          label: BPQuestionLabels.MinMandatoryBrokerFeeRate,
          field: "minMandatoryBrokerFeeRate",
          value: minMandatoryBrokerFee,
          size: 4,
          inputType: "percent",
          condition: FeatureFlags.IS_BROKER_FEE_ALLIANCE
        },
        {
          label: BPQuestionLabels.TotalBrokerFeeRate,
          field: "brokerFeeRate",
          value: operationOfNumberArray("sum", [props.gmrObject.brokerFeeRate, props.gmrObject.wlbrokerFeeRate, minMandatoryBrokerFee]),
          size: 4,
          inputType: "percent",
          condition: FeatureFlags.IS_BROKER_FEE_ALLIANCE
        },
        {
          label: BPQuestionLabels.BrokerAssociated,
          field: "isBrokerInvolved",
          value: props.gmrObject.brokerEmail ? "Yes" : "No",
          size: 4,
          dropdown: [
            {
              key: "56ab2483-9fa5-4c13-b62b-870f24cff5c2",
              text: "Yes",
              value: "Yes"
            },
            {
              key: "38b2295e-ee0c-4fc2-932d-aef4a8bac31e",
              text: "No",
              value: "No"
            }
          ],
          yesNo: convertToYesNo,
          readonly: true,
          condition: FeatureFlags.IS_BETA,
          isOverride: true
        },
        {
          label: "What is the broker's email address?",
          field: "brokerEmail",
          value: props.gmrObject.brokerEmail,
          size: 4,
          readonly: true,
          condition: FeatureFlags.IS_BETA,
          isOverride: true
        },
        {
          label: BPQuestionLabels.LoanOfficer,
          field: "loanOfficerOrganizationContactId",
          value: handleGetValueFromId(props.gmrMetadata.loanOfficers, props.gmrObject.loanOfficerOrganizationContactId),
          size: 4,
          dropdown: props.gmrMetadata.loanOfficers && getDropdownOptions(props.gmrMetadata.loanOfficers, ["id"], "name"),
          metadataArray: props.gmrMetadata.loanOfficers,
          readonly: true
        },
        {
          label: BPQuestionLabels.BorrowingEntity,
          field: "borrowerOrganizationId",
          value: handleGetValueFromId(props.associatedBorrowers, props.gmrObject.borrowerOrganizationId, "name"),
          size: 4,
          dropdown: props.associatedBorrowers && getDropdownOptions(props.associatedBorrowers, ["id"], "name"),
          metadataArray: props.associatedBorrowers,
          readonly: true,
          condition: FeatureFlags.IS_BETA
        },
        {
          label: "What is the company type?",
          field: "borrowerEntitySubTypeId",
          value: handleGetValueFromId(props.gmrMetadata.entitySubTypes, handleTransformGmrObjectWithInfo(props.gmrObject).borrowerEntitySubTypeId),
          size: 4,
          dropdown: props.gmrMetadata.entitySubTypes && getDropdownOptions(props.gmrMetadata.entitySubTypes, ["id"], "name"),
          metadataArray: props.gmrMetadata.entitySubTypes,
          readonly: true,
          condition: FeatureFlags.IS_BETA
        },
        {
          label: "What is the company address?",
          address: handleAddressValue({
            address: handleTransformGmrObjectWithInfo(props.gmrObject).borrowerStreet,
            city: handleTransformGmrObjectWithInfo(props.gmrObject).borrowerCityName,
            state: handleTransformGmrObjectWithInfo(props.gmrObject).borrowerStateName,
            zip: handleTransformGmrObjectWithInfo(props.gmrObject).borrowerZip
          }),
          value: handleAddressValue({
            address: props.gmrObject.borrowerStreet,
            city: props.gmrObject.borrowerCityName,
            state: props.gmrObject.borrowerStateName,
            zip: props.gmrObject.borrowerZip
          }),
          size: 4,
          readonly: true,
          condition: FeatureFlags.IS_BETA
        }
      ]}
    />
  };

  return (
    <div className={(props.isGreaterThanTablet && props.isSidebar) ? "landing-page hide-sidebar" : "landing-page sidebar"}>
      <Grid>
        <Grid.Row className="padding-top">
        <Grid.Column width={3} className="primary-details">
          <BCFormInput 
            labelClass="gmr-background-label-white"
            label=""
          />
        </Grid.Column>
        <Grid.Column className="primary-details" width={4}>
          <BCFormInput
            type="input"
            value="Original"
            obj={props.gmrScenarios}
            field="name"
            inputType="text"
            handleFormChange={() => void 0}
          />
        </Grid.Column>
        {props.gmrScenarios.map((scenario, i) => {
          return(
            <Grid.Column key={i} className="primary-details" width={4}>
              <BCFormInput
                type="input"
                placeholder="Construction Loan Services II"
                value={scenario.name}
                obj={props.gmrScenarios}
                field="name"
                inputType="text"
                handleFormChange={(value, field) => handleScenarioFormChange(
                  value,
                  field,
                  props.gmrScenarios,
                  props.setGmrScenarios,
                  GlobalConstants.InputTypes.STRING,
                  undefined,
                  undefined,
                  i
                )}
              />
            </Grid.Column>
        );})} 
        </Grid.Row>
      </Grid>
      {FeatureFlags.IS_BC_PRICING && <BCAccordion titleClass="scenario-accordion-title-first" accordion={pricingAccordion}></BCAccordion>}
      {!props.isAnonymous && <React.Fragment>
        <BCAccordion accordion={overviewAccordion}></BCAccordion>
        <BCAccordion accordion={budgetAccordion}></BCAccordion>
        <BCAccordion accordion={projectAccordion}></BCAccordion>
        <BCAccordion accordion={financingAccordion}></BCAccordion>
        <BCAccordion accordion={backgroundAccordion}></BCAccordion>
      </React.Fragment>}
    </div>
  );

};

export default BPPricingScenario;
